export const heroSectionData = {
  title: '<span class="emoji">👋</span> Hi there, I\'m Ming',
  tagline:
    "Scientist. Developer. Entrepreneur. Believer in the power of science and technology to improve health and quality of life.",
};
